import { BigNumber } from '@ethersproject/bignumber';
import { getCurrentBlockTimestamp } from '@silo/contract-utils';
import { SiloLens } from '@silo/typechain';
import { ChecksumAddress, ClientProvider } from '@silo/types';
import { durationToSeconds } from '@silo/utils';
import { Duration } from 'date-fns';

type GetBorrowAmount = (params: {
  clientProvider: ClientProvider;
  siloLens: SiloLens;
  siloAddress: ChecksumAddress;
  assetAddress: ChecksumAddress;
  user: ChecksumAddress;
  futureDuration?: Duration;
}) => Promise<BigNumber>;

export const getBorrowAmount: GetBorrowAmount = async ({
  clientProvider,
  siloLens,
  siloAddress,
  assetAddress,
  user,
  futureDuration = {},
}) => {
  const currentBlockTimestamp = await getCurrentBlockTimestamp(clientProvider);
  const futureTimestamp = currentBlockTimestamp + durationToSeconds(futureDuration);

  return await siloLens.getBorrowAmount(siloAddress, assetAddress, user, futureTimestamp);
};
